import * as editorLink from './20210719-editor-link';
import * as banner from './20210802-banner';
import * as backgroundText from './20220117-background-text';
import * as photoMosaic from './20220321-photo-mosaic';
import * as moduleGeneric from './20220323-module-generic';
import * as headers from './20220401-headers';
import * as globalData from './20220428-global-data';
import * as newFooterLinks from './20220404-new-footer-links';
import * as url from './20220513-url';
import * as gtm from './20220531-gtm';
import * as fontCalibri from './20220615-font-calibri';
import * as newFooterContacts from './20220617-new-footer-contacts';
import * as header from './20220526-header';
import * as headersNew from './20220526-headers';
import * as bannerNew from './20220603-banner';
import * as widget from './20220622-widget';
import * as idsCrm from './20220906-ids-crm';
import * as social from './20221116-social';
import * as promoMultiLinks from './20221128-promo-multi-links';
import * as footerSocialLinks from './20221125-footer-social-links';
import * as promoListSorter from './20221212-promo-list-sorter';
import * as dynamicUrl from './20230331-dynamic-url';
import * as contact from './20230616-contact';
import * as precheckin from './20230620-precheckin';
import * as amenities from './20230810-amenities';
import * as bannerH1 from './20230922-banner-h1';
import * as simpleTextColumns from './20240214-simple-text-columns';
import * as simpleText from './20240219-simple-text';
import * as indexing from './20240503-indexing-page';
import * as nameHotel from './20240701-name-hotel';
import migrate from '../migrate';

export const migrations = [
  editorLink,
  banner,
  backgroundText,
  photoMosaic,
  moduleGeneric,
  headers,
  globalData,
  newFooterLinks,
  url,
  gtm,
  fontCalibri,
  newFooterContacts,
  header,
  headersNew,
  bannerNew,
  widget,
  idsCrm,
  social,
  promoMultiLinks,
  footerSocialLinks,
  promoListSorter,
  dynamicUrl,
  contact,
  precheckin,
  amenities,
  bannerH1,
  simpleTextColumns,
  simpleText,
  indexing,
  nameHotel,
];

export default migrate(migrations);
